const Game = require('@/tbs/model/to/Game')
const game = new Game
/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_GameEvent = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_GameEvent.prototype = {
    /* The view object name */
    name: 'event',
    /* The view object instance */
    view: {
        manage: [
            {
                name: 'homeTeamPlayers',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMBktGameEventPlayerList',
                basePath: 'data.playerList',
                rule: {
                    id: 'id',
                    name: 'trueName',
                    label: '$trueName,number',
                    value: 'id',
                    num: 'number',
                }
            },
            {
                name: 'awayTeamPlayers',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetBMBktGameEventPlayerList',
                basePath: 'data.playerList',
                rule: {
                    id: 'id',
                    name: 'trueName',
                    label: '$trueName,number',
                    value: 'id',
                    num: 'number',
                }
            },
        ],
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmteam/',
            service: 'getBMGameEvents',
            basePath: 'data.gameEvents',
            rule: {
                id: 'id',
                teamId: 'teamId',
                gameId: 'gameId',
                time: 'time',
                type: 'type',
                firstPlayerNum: 'userNumber',
                firstPlayerName: 'userName',
                firstPlayerId: 'playerId',
                secondPlayerNum: 'otherNumber',
                secondPlayerName: 'otherName',
                secondPlayerId: 'otherPlayerId',
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmteam/',
            service: 'getBMGameEvent',
            basePath: 'data.event',
            rule: {
                id: 'id',
                teamId: 'teamId',
                gameId: 'gameId',
                time: 'time',
                eventType: '$type',
                eventSpecType: 'type',
                firstPlayerNum: 'userNumber',
                firstPlayerName: 'userName',
                firstPlayerId: 'playerId',
                secondPlayerNum: 'otherNumber',
                secondPlayerName: 'otherName',
                secondPlayerId: 'otherPlayerId',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminAddBMGameEvent',
            basePath: '',
            rule: {
                gameId: 'gameId',
                teamId: 'teamId',
                time: 'time',
                event: 'eventType',
                type: '$eventType,eventSpecType',
                playerId: 'firstPlayerId',
                otherPlayerId: 'secondPlayerId',
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateBMGameEvent',
            basePath: '',
            rule: {
                eventId: 'id',
                gameId: 'gameId',
                teamId: 'teamId',
                time: 'time',
                event: 'eventType',
                type: '$eventType,eventSpecType',
                playerId: 'firstPlayerId',
                otherPlayerId: 'secondPlayerId',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminDeleteBMGameEvent',
            basePath: '',
            rule: {
                eventId: 'id'
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderEventType: function(type) {
        if (type == 'goal' || type == 'penalty' || type == 'ownGoal') {
            return '1'
        }
        else if (type == 'red' || type == 'yellow') {
            return '2'
        }
        else if (type == 'changes') {
            return '3'
        }
    },
    formatType: function(eventType, eventSpecType) {
        if (eventType == '3') {
            return 'changes'
        }
        else {
            return eventSpecType
        }
    },
    renderLabel: function(trueName, number) {
        return (number ? number + ' ' : '')  + trueName
    },
    getEventTypes: function() {
        return [
            { label: game.localeProp('goal'), value: '1' },
            { label: game.localeProp('red-yellow-card'), value: '2' },
            { label: game.localeProp('substitution'), value: '3' },
        ]
    },
    getEventSpecTypes: function(eventType) {
        if (eventType == 1) {
            return [
                { label: game.localeProp('normal'), value: 'goal' },
                { label: game.localeProp('penalty-goal'), value: 'penalty' },
                { label: game.localeProp('own-goal'), value: 'ownGoal' },
            ]
        }
        else if (eventType == 2) {
            return [
                { label: game.localeProp('red-card'), value: 'red' },
                { label: game.localeProp('yellow-card'), value: 'yellow' },
            ]
        }
        else {
            return []
        }
    },
    getFirstPlayerLabel: function(eventType) {
        if (eventType == '1') {
            return game.localeProp('event-goal-player')
        }
        else if (eventType == '2') {
            return game.localeProp('event-card-player')
        }
        else if (eventType == '3') {
            return game.localeProp('event-sub-out-player')
        }
        else {
            return ''
        }
    },
    getSecondPlayerLabel: function(eventType, eventSpecType) {
        if (eventType == '1' && eventSpecType == 'goal') {
            return game.localeProp('event-assist-player')
        }
        else if (eventType == '3') {
            return game.localeProp('event-sub-in-player')
        }
        else {
            return ''
        }
    },
    validateSecondPlayerRequired: function(eventType) {
        if (eventType == '3') {
            return true
        }
        return false
    },
    validateEventSpecTypeRequired: function(eventType) {
        if (eventType == '1' || eventType == '2') {
            return true
        }
        return false
    },
    defaultEventType: '1',
    defaultEventSpecType: 'goal'
}

module.exports = tbs_model_vo_GameEvent